<template>
  <div class="h-screen bg-img container" id="page-login">
    <div class="col-12 col-md-10 mx-auto my-auto login-wrapper">
      <div class="card auth-card">
        <div class="position-relative image-side">
          <p class="text-white h2 title">
            {{ $store.state.auth.login_parameters.web_title }}
          </p>
          <p class="white mb-0 subtitle">
            {{ $store.state.auth.login_parameters.web_subtitle }}
          </p>
        </div>

        <div class="form-side" id="login-form" v-show="!forgotPassword">
          <a href="#">
            <img
              v-if="parameters.web_logo"
              :src="parameters.web_logo"
              class="logo"
              alt="logo"
            />
          </a>
          <h5 class="mb-4">Login</h5>
          <form @submit.prevent="login">
            <label class="form-group has-float-label mb-4">
              <input
                class="form-control"
                v-model="email"
              />
              <span class="hint">{{ parameters.email_label }}</span>
            </label>

            <label class="form-group has-float-label mb-4">
              <input
                class="form-control"
                type="password"
                v-model="password"
              />
              <span class="hint">{{ parameters.password_label }}</span>
            </label>

            <div class="d-flex justify-content-between align-items-center">
              <button class="link-btn" type="button" @click="toggleForgot">
                {{ parameters.forgot_label }}
              </button>
              <button class="btn btn-primary btn-lg btn-shadow" type="submit">
                {{ parameters.submit_button_label }}
              </button>
            </div>
          </form>
        </div>

        <div class="form-side" id="forgot-form" v-show="forgotPassword">
          <h5 class="mb-4">{{ parameters.web_forgot_password_title }}</h5>
          <form @submit.prevent="recoverPassword">
            <label class="form-group has-float-label mb-4">
              <input class="form-control" v-model="email" />
              <span class="hint">{{ parameters.web_forgot_password_email_label }}</span>
            </label>
            <div class="d-flex justify-content-between align-items-center">
              <button class="link-btn" type="button" @click="toggleForgot">
                Voltar ao login
              </button>
              <button class="btn btn-primary btn-lg btn-shadow" type="submit">
                {{ parameters.web_forgot_password_btn_label }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setApplicationLocalStorageItem } from "../../../helpers";

export default {
  data() {
    return {
      parameters: {
        email_label: "Email",
        password_label: "Senha",
        remember_label: "",
        submit_button_label: "Enviar",
        forgot_label: "Esqueceu sua senha ?",
        web_background: "",
        web_card_logo: "",
        web_forgot_password_title: "Recuperação de senha",
        web_forgot_password_email_label: "Email",
        web_forgot_password_btn_label: "Enviar",
        web_logo: "",
      },
      app_token: "",
      api_url: "",
      use_microsoft_sso: false,
      email: "",
      password: "",
      forgotPassword: false,
    };
  },
  mounted() {
    const lp = this.$store.state.auth.login_parameters;
    this.parameters = {
      ...this.parameters,
      email_label: lp.web_username_label,
      password_label: lp.web_password_label,
      remember_label: lp.web_remember_label,
      forgot_label: lp.web_forgot_label,
      submit_button_label: lp.web_submit_btn_text,
      web_background: lp.web_background,
      web_card_logo: lp.web_card_logo,
      web_forgot_password_title: lp.web_forgot_password_title,
      web_forgot_password_email_label: lp.web_forgot_password_email_label,
      web_forgot_password_btn_label: lp.web_forgot_password_btn_label,
      web_logo: lp.web_logo,
    };

    document.title = lp.web_tab_title;
    setApplicationLocalStorageItem(
      "documentTitle",
      lp.web_tab_title.split(" | ")[0]
    );

    const fixedBack = document.createElement("div");
    fixedBack.className = "fixed-background";
    document.body.prepend(fixedBack);
    document.body.className = "ltr rounded background";

    const background = document.querySelector(".fixed-background");
    if (background) {
      background.style.cssText = `background: url(${lp.web_background}) no-repeat center center fixed; background-size: cover; width: 100%; height: 100%; position: fixed; top: 0; right: 0; bottom: 0; left: 0;`;
    }
    const imageSide = document.querySelector(".auth-card .image-side");
    if (imageSide) {
      imageSide.style.cssText = `background: url(${lp.web_card_logo}) no-repeat center; padding: 80px 40px;`;
    }
  },
  methods: {
    toggleForgot() {
      this.forgotPassword = !this.forgotPassword;
    },
    async login() {
      this.$vs.loading();
      const payload = {
        userDetails: { email: this.email, password: this.password },
        api_url: this.api_url,
        app_token: this.app_token,
      };

      this.$store
        .dispatch("auth/login", payload)
        .then(() => {
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: e.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    async recoverPassword() {
      this.$vs.loading({ type: "default" });
      return fetch(`${this.$store.state.auth.api_url}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          command: "request_change_user_password_token",
          parameters: {
            application_token: `${this.$store.state.auth.app_token}`,
            user_email: this.email,
          },
        }),
      })
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Email encaminhado!",
            text: `Encaminhamos um email para ${this.email} com as instruções de recuperação de senha!`,
            iconPack: "feather",
            icon: "icon-success-circle",
            color: "success",
          });
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Email encaminhado!",
            text: `Encaminhamos um email para ${this.email} com as instruções de recuperação de senha!`,
            iconPack: "feather",
            icon: "icon-success-circle",
            color: "success",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.login-wrapper {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.auth-card {
  margin: 0 auto 10px;
  float: none;
}

.image-side {
  min-height: 200px;
  color: #fff;
}

.form-side {
  padding: 40px 30px;
}

.title {
  font-size: 32px;
}

.subtitle {
  font-size: 15px;
}

.logo {
  width: auto;
  height: 68px;
  margin-bottom: 30px;
  margin-top: -20px;
}

.hint {
  font-size: 12px;
  color: #8f8f8f;
}

.link-btn {
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  color: #8f8f8f;
  cursor: pointer;
}

@media (max-width: 768px) {
  .image-side {
    background: none !important;
    padding: 40px 30px !important;
  }
  .logo {
    margin-bottom: 10px !important;
  }
}
</style>

